<template>
    <div class="hero-image">
        <div class="hero-image--container">
            <base-image class="hero-image--image" loading="lazy" v-bind="image"/>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            image: {
                type: Object,
                required: true,
            },
        },
    };
</script>
